import organizationServices from "@/services/organization.js";
const state = {
  allOrganizations: [],
  selectedOrg: null,
};

const getters = {
  allOrganizations(state) {
    return state.allOrganizations;
  },
  selectedOrg(state) {
    return state.selectedOrg;
  }
};

const mutations = {
  SET_ALL_ORGANIZATIONS: (state, allOrganizations) => {
    state.allOrganizations = allOrganizations;
  },
  SET_SELECTED_ORG: (state, selectedOrg) => {
    state.selectedOrg = selectedOrg;
  },
};

const actions = {
  async setAllOrganizations({ commit }) {
    organizationServices.list({
      offset: 0,
      limit: 999,
      locale: "vi",
      sort: "-created"
    }).then((response) => {
      commit("SET_ALL_ORGANIZATIONS", response.items || []);
      commit("SET_SELECTED_ORG", response.items[0] || null);
    }).catch(() => {
      commit("SET_ALL_ORGANIZATIONS", []);
      commit("SET_SELECTED_ORG", null);
    });
  },
  setSelectedOrg({ commit }, selectedOrg) {
    commit("SET_SELECTED_ORG", selectedOrg);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
